// import axios from "axios";
// import { serverConfig,POST_LOGIN_UUID,PRE_LOGIN_UUID } from "../../ApiSearchPath/ApiSearchPath";
// import { refreshToken } from "./authService";

// const axiosInstance = axios.create({
//   baseURL: serverConfig.BASE_URL,
//   withCredentials: true,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// // ✅ REQUEST INTERCEPTOR
// axiosInstance.interceptors.request.use(
//   (config) => {
//     const isPreLogin = config.headers.authType === "PreLogin";
//     config.headers.Authorization = isPreLogin ? PRE_LOGIN_UUID : POST_LOGIN_UUID;
//     if (config.headers.baseURL==="baseURL2") {
//       config.baseURL = serverConfig.BASE_URL2;
//       delete config.headers.baseURL; // keep headers clean
//     }
//     if (config.data instanceof FormData) {
//     // ✅ let browser set multipart boundary
//     delete config.headers["Content-Type"];
//   } else {
//     config.headers["Content-Type"] = "application/json";
//   }
//     if (!isPreLogin) {
//       const token = getAccessToken();
//       if (token) {
//         config.headers.accessToken = token;
//       }
//     } else {
//       delete config.headers.accessToken;
//     }

//     // Force PostLogin on /auth/verify
//     if (config.url === "/auth/verify") {
//       const token = getAccessToken();
//       if (token) {
//         config.headers.accessToken = token;
//         config.headers.authType = "PostLogin";
//         config.headers.Authorization = POST_LOGIN_UUID;
//       }
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // ✅ RESPONSE INTERCEPTOR
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     // Debug log
//     console.log("❗ Response Error Interceptor", {
//       status: error.response?.status,
//       url: originalRequest?.url,
//       authType: originalRequest?.headers?.authType,
//     });

//     if (
//       error.response?.status === 401 &&
//       !originalRequest._retry &&
//       originalRequest.headers?.authType !== "PreLogin"
//     ) {
//       originalRequest._retry = true;
//       try {
//          const response = await refreshToken();

//   if (!response || !response.token || !response.refreshToken) {
//     console.warn(" Refresh returned null or incomplete tokens");
//     clearTokens();
//     return Promise.reject({ message: "Session expired" });
//   }
//         const { token: newAccessToken, refreshToken: newRefreshToken } = response;
//         saveTokens({ accessToken: newAccessToken, refreshToken: newRefreshToken });

//         originalRequest.headers.accessToken = newAccessToken;

//         return axiosInstance(originalRequest); // ✅ Retry original request
//       } catch (refreshError) {
//   console.error("🔒 Refresh failed:", refreshError);

//   // Clear all tokens and session
//   clearTokens();
//   localStorage.clear();

//   // 🔔 Notify React (AuthContext) that session expired
//   window.dispatchEvent(new Event("auth-expired"));

//   return Promise.reject(refreshError);
// }
//     }

//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;

import axios from "axios";
import { serverConfig, POST_LOGIN_UUID, PRE_LOGIN_UUID } from "../../ApiSearchPath/ApiSearchPath";
import { refreshToken } from "./authService";

// ✅ Axios instance
const axiosInstance = axios.create({
  baseURL: serverConfig.BASE_URL,
  withCredentials: true, // allow browser to send HttpOnly cookies
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ REQUEST INTERCEPTOR
axiosInstance.interceptors.request.use(
  (config) => {
    const isPreLogin = config.headers.authType === "PreLogin";

    // Set Authorization UUID depending on Pre/Post login
    config.headers.Authorization = isPreLogin ? PRE_LOGIN_UUID : POST_LOGIN_UUID;

    // Switch baseURL if needed
    if (config.headers.baseURL === "baseURL2") {
      config.baseURL = serverConfig.BASE_URL2;
      delete config.headers.baseURL;
    }

    if (config.headers.baseURL === "baseURL3") {
      config.baseURL = serverConfig.BASE_URL3;
      delete config.headers.baseURL;
    }

    // Handle FormData (let browser set multipart boundary)
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    // Force PostLogin on /auth/verify
    if (config.url === "/auth/verify") {
      config.headers.authType = "PostLogin";
      config.headers.Authorization = POST_LOGIN_UUID;
    }

    // ✅ Remove all token headers: cookies handle auth now
    delete config.headers.accessToken;

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ RESPONSE INTERCEPTOR
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    console.log("❗ Response Error Interceptor", {
      status: error.response?.status,
      url: originalRequest?.url,
      authType: originalRequest?.headers?.authType,
    });

    // If 401 and not PreLogin, try refresh (cookie-based)
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      originalRequest.headers?.authType !== "PreLogin"
    ) {
      originalRequest._retry = true;

      try {
        // refreshToken will make POST /auth/refresh and backend sets new cookie
        await refreshToken();

        // Retry original request without adding token manually
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        console.error("🔒 Refresh failed:", refreshError);

        // Notify React AuthContext
        window.dispatchEvent(new Event("auth-expired"));

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;